import { doc, updateDoc } from "firebase/firestore";
import { db } from "../../firebase";
import HelperForMetaData from "../../Helpers/HelperForMetaData";

const UpdateNotificationStatus = async (notificationID) => {
  try {
    const NotificationDocument = doc(db, "notifications", notificationID);

    const data = {
      is_seen: true,
      ...HelperForMetaData({}),
    };

    delete data.createdAt;
    delete data.createdBy;

    await updateDoc(NotificationDocument, data, { merge: true });

    return true;
  } catch (error) {
    console.log(error);

    return false;
  }
};

export default UpdateNotificationStatus;
